module.exports = __webpack_public_path__ + "static/media/fl_map600.a08d6f76.gif";